var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    viewBox: "0 0 10 10",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12v12h-12z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 9 2 1.5v-1.5h.5c.5525 0 1-.4475 1-1v-3c0-.5525-.4475-1-1-1h-4c-.5525 0-1 .4475-1 1v3c0 .5525.4475 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 7.5-1.5 1v-1.5h-.5c-.5525 0-1-.4475-1-1v-3c0-.5525.4475-1 1-1h4.5c.5525 0 1 .4475 1 1v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.2152 6.4823c.0097631.0097631.0097631.02559225 0 .03535535s-.02559225.0097631-.03535535 0-.0097631-.02559225 0-.03535535.02559225-.0097631.03535535 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5177 6.4823c.0097631.0097631.0097631.02559225 0 .03535535s-.02559225.0097631-.03535535 0-.0097631-.02559225 0-.03535535.02559225-.0097631.03535535 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.8202 6.4823c.0097631.0097631.0097631.02559225 0 .03535535s-.02559225.0097631-.03535535 0-.0097631-.02559225 0-.03535535.02559225-.0097631.03535535 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSecond);
export default __webpack_public_path__ + "static/media/chat-second.710622c009446fb390056d536a07d79d.svg";
export { ForwardRef as ReactComponent };